import { Alert } from "@mui/material"
import React, { useEffect } from "react"
import { useAppSelector, useAppDispatch } from "../../../../../app/hooks"
import { usePayerDetailsQuery, useCenterFindQuery } from "../../../../../services/orgService/org-api";
import { PayerForCenterRequest } from "../../../../../services/orgService/commands";
import { usePrimaryPayerCode } from "../../../hooks/usePrimaryPayerCode";
import { RequiresMedicareAuth } from "../../../specs/RequiresMedicareAuth";
import { RequiresCignaAuth } from "../../../specs/RequiresCignaAuth";
import { RequiresAetnaAuth } from "../../../specs/RequiresAetnaAuth";
import { RequiresBCBSAuth } from "../../../specs/RequiresBCBSAuth";
import { useParams } from "react-router";
import { useCaseFindQuery } from "../../../../../services/scheduleService/schedule-api";
import { RequiresTriwestAuth } from "../../../specs/RequiresTriwestAuth";
import { RequiresUhcAuth } from "../../../specs/RequiresUhcAuth";
import { RequiresWellMedAuth } from "../../../specs/RequiresWelmedAuth";
import { RequiresHealthTexasAuth } from "../../../specs/RequiresHealthTexasAuth";
import { RequiresReferralNumber } from "../../../specs/RequiresReferralNumber";
import { RequiresBcbsT2GAuth } from "../../../specs/RequiresBcbsT2GAuth";
import { toggleHumanaReferralWarningDialog, setBcbsT2GWarningDialog } from "../../../../../app/slices/VerificationModuleSlice";
import { HumanaReferralWarningDialog } from "./HumanaReferralWarningDialog";
import { BcbsT2GWarningDialog } from "./BcbsT2GWarningDialog";

function AuthorizationWarnings(){
    const {id} = useParams();
    const verify = useAppSelector((state) => state.verification.verification);
    const dispatch = useAppDispatch();
    const currentTab = useAppSelector((state) => state.verificationModule.DetailTab);
    const schedule = useCaseFindQuery(id!);
    const primaryPayer = schedule.data?.insurances.find(p => p.priority === 1);
    const center = useCenterFindQuery(verify.center);
    const payerCode = usePrimaryPayerCode();
    const calctype = usePayerDetailsQuery(new PayerForCenterRequest(verify.center, payerCode)).data?.financialClass;

    const isBcbsCalctype = calctype?.includes('BCBS') ?? false;
    const isT2G = primaryPayer ? new RequiresBcbsT2GAuth().IsSatisfiedBy(primaryPayer) : false;

    useEffect(() => {
        if (currentTab === 2 && // Authorization tab index is 2
            (calctype === 'Humana' || calctype === 'Humana Medicare') &&
            !new RequiresReferralNumber().IsSatisfiedBy(verify)) {
            dispatch(toggleHumanaReferralWarningDialog());
        }
    }, [currentTab, calctype, verify, dispatch]);

    useEffect(() => {
        dispatch(setBcbsT2GWarningDialog(currentTab === 2 && isBcbsCalctype && isT2G));
    }, [currentTab, isBcbsCalctype, isT2G, dispatch]);

    return <React.Fragment>
        {primaryPayer && new RequiresHealthTexasAuth().IsSatisfiedBy(primaryPayer) &&
        <Alert color="warning">Case is Health Texas, a separate facility authorizaton is needed</Alert>
        }
        {calctype === 'Medicare' && new RequiresMedicareAuth().IsSatisfiedBy(verify) &&
        <Alert color="error">Medicare requires authorization for one or more procedure codes on this case.</Alert>}
        {(calctype === 'BCBS Trad' || calctype==='BCBS PPO' || calctype==='BCBS NWB' || calctype==='BCBS HMO' || calctype==='BCBS Blue Essential' || calctype==='BCBS BAV') 
            && new RequiresBCBSAuth().IsSatisfiedBy(verify) &&
        <Alert color="error">BCBS requires authorization for one or more procedure codes on this case.</Alert>
        }
        {calctype === 'Aetna' && new RequiresAetnaAuth().IsSatisfiedBy(verify) &&
        <Alert color="error">Aetna requires authorization for one or more procedure codes on this case.</Alert>
        }
        {calctype === 'Cigna' && new RequiresCignaAuth().IsSatisfiedBy(verify) &&
        <Alert color="error">Cigna requires authorization for one or more procedure codes on this case.</Alert>
        }
        {calctype === 'TriWest' && new RequiresTriwestAuth().IsSatisfiedBy(verify) &&
        <Alert color="error">TriWest requires authorization for one or more procedure codes on this case.</Alert>
        }
        {calctype === 'UHC' && new RequiresUhcAuth().IsSatisfiedBy(verify) &&
        <Alert color="error">United Healthcare requires authorization for one or more procedure codes on this case.</Alert>
        }
        {calctype === 'Wellmed' && new RequiresWellMedAuth().IsSatisfiedBy(verify) &&
        <Alert color="error">WellMed requires authorization for one or more procedure codes on this case.</Alert>
        }
        {(calctype === 'Humana' || calctype === 'Humana Medicare') && !new RequiresReferralNumber().IsSatisfiedBy(verify) &&
        <Alert color="error">Referral number is required for Humana and Humana Medicare cases</Alert>
        }
        {isBcbsCalctype && isT2G &&
        <Alert color="error">BCBS T2G plan detected — PCP referral and facility authorization are required.</Alert>
        }
        <HumanaReferralWarningDialog />
        <BcbsT2GWarningDialog />
    </React.Fragment>
}

export {AuthorizationWarnings}